const isPTPrescaledWithSUV = (image) => {
    return Boolean(image.preScale?.scaled && image.preScale?.scalingParameters?.suvbw);
};
export default isPTPrescaledWithSUV;
